export default ['$uibModalInstance', function ($uibModalInstance) {
  // TODO удалить модалку когда будет сделана нотификация в правом углу
  this.close = () => {
    $uibModalInstance.dismiss('sent');
  };
}];
